import { render } from "./investList.vue?vue&type=template&id=d291ffe0&scoped=true"
import script from "./investList.vue?vue&type=script&lang=js"
export * from "./investList.vue?vue&type=script&lang=js"

import "./investList.vue?vue&type=style&index=0&id=d291ffe0&lang=less&scoped=true"

import exportComponent from "/var/www/html/pro-cms-dtinsights/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d291ffe0"]])

export default __exports__